<template>
	<!-- <div class="py-4 container-fluid"> -->
	<div>
		<ToastPrime position="bottom-left" />
		<!-- MRC ITEM TABLE (header/toolbar-nya di New_McrItem.vue) -->
		<div class="card-body pt-0 px-0" style="max-height: 400px; overflow-y: auto;">
			<DataTable :value="isTableLoading ? dummyRows : items" removable-sort scrollable scroll-height="flex"
				table-style="min-width: 100%; width: max-content" selection-mode="single" :row-class="rowClass"
				class="p-datatable-sm user-item-table"
				@row-select="onRowSelect">
				<Column header="" header-class="bg-light text-dark" body-class="cell-actions" style="width: 170px;">
					<template #body="slotProps">
						<Skeleton v-if="isTableLoading"></Skeleton>
						<div v-else style="display: inline-flex; align-items: center; gap: 4px;">
							<ButtonPrime v-tooltip.bottom="'MCR Item Note'" icon="pi pi-file-edit" rounded outlined
								size="small" @click.stop="openNoteModal(slotProps.data)" />
							<ButtonPrime v-if="hasDuplicateSource(slotProps.data)" v-tooltip.bottom="'Check Duplicate'"
								icon="pi pi-copy" rounded outlined severity="warning" size="small"
								@click.stop="openCheckDuplicateDialog(slotProps.data)" />
							<ButtonPrime v-if="cancelVisible(slotProps.data)"
								v-tooltip.bottom="'Cancel'" icon="pi pi-ban" rounded outlined severity="danger"
								size="small" @click.stop="onCancelItem(slotProps.data)" />
							<span v-if="slotProps.data.status" v-tooltip.bottom="statusBadgeTooltip(slotProps.data)"
								class="badge" :class="statusBadgeClass(slotProps.data.status)"
								:style="statusBadgeStyle(slotProps.data.status)"
								style="font-size: 0.7rem; padding: 2px 4px; min-width: 0;">{{
									statusBadgeLabel(slotProps.data.status) }}</span>
						</div>
					</template>
				</Column>
				<Column v-if="!isService && mcrType == 'mcr002'" field="material_number" header="MATERIAL NUMBER"
					header-class="bg-light text-dark" sortable>
					<template #body="slotProps">
						<Skeleton v-if="isTableLoading"></Skeleton>
						<span v-else>{{ slotProps.data && slotProps.data.material_number ?
							formatMaterialNumber(slotProps.data.material_number) : '' }}</span>
					</template>
				</Column>
				<Column v-if="!isService" field="material_type" header="MATERIAL TYPE" header-class="bg-light text-dark"
					sortable>
					<template #body="slotProps">
						<Skeleton v-if="isTableLoading"></Skeleton>
						<span v-else>{{ slotProps.data && slotProps.data.material_type ? slotProps.data.material_type :
							'' }}</span>
					</template>
				</Column>
				<Column v-if="!isService" field="material_group" header="MATERIAL GROUP"
					header-class="bg-light text-dark" sortable>
					<template #body="slotProps">
						<Skeleton v-if="isTableLoading"></Skeleton>
						<span v-else>{{ slotProps.data && slotProps.data.material_group ? slotProps.data.material_group
							: '' }}</span>
					</template>
				</Column>
				<Column v-if="!isService" field="plant" header="PLANT" header-class="bg-light text-dark" sortable>
					<template #body="slotProps">
						<Skeleton v-if="isTableLoading"></Skeleton>
						<span v-else>{{ slotProps.data && slotProps.data.plant ? slotProps.data.plant : '' }}</span>
					</template>
				</Column>
				<!-- MCR003 (Extend): plant sumber "Copy From" (ext_cf_plant) di samping plant tujuan. -->
				<Column v-if="!isService && mcrType == 'mcr003'" field="ext_cf_plant" header="COPY FROM PLANT"
					header-class="bg-light text-dark" sortable>
					<template #body="slotProps">
						<Skeleton v-if="isTableLoading"></Skeleton>
						<span v-else>{{ slotProps.data && slotProps.data.ext_cf_plant ? slotProps.data.ext_cf_plant : '' }}</span>
					</template>
				</Column>
				<Column v-if="isService" field="service_group" header="SERVICE GROUP" header-class="bg-light text-dark"
					sortable>
					<template #body="slotProps">
						<Skeleton v-if="isTableLoading"></Skeleton>
						<span v-else>{{ slotProps.data && (slotProps.data.service_group ||
							slotProps.data.cat_service_group) ? (slotProps.data.service_group ||
								slotProps.data.cat_service_group) : '' }}</span>
					</template>
				</Column>
				<Column v-if="isService" field="service_category" header="SERVICE CATEGORY"
					header-class="bg-light text-dark" sortable>
					<template #body="slotProps">
						<Skeleton v-if="isTableLoading"></Skeleton>
						<span v-else>{{ slotProps.data && (slotProps.data.service_category ||
							slotProps.data.cat_service_category) ? (slotProps.data.service_category ||
								slotProps.data.cat_service_category) : '' }}</span>
					</template>
				</Column>
				<Column field="uom" header="UOM" header-class="bg-light text-dark" sortable body-class="text-nowrap">
					<template #body="slotProps">
						<Skeleton v-if="isTableLoading"></Skeleton>
						<span v-else>{{ slotProps.data && slotProps.data.uom ? slotProps.data.uom : '' }}</span>
					</template>
				</Column>
				<Column field="specification" header="SPECIFICATION" header-class="bg-light text-dark" sortable>
					<template #body="slotProps">
						<Skeleton v-if="isTableLoading"></Skeleton>
						<span v-else :title="slotProps.data?.specification || ''">{{ truncateText(slotProps.data?.specification, 40) }}</span>
					</template>
				</Column>
				<Column header="Actions" header-class="bg-light text-dark" body-class="cell-actions"
					body-style="text-align: center; width: 80px;">
					<template #body="slotProps">
						<Skeleton v-if="isTableLoading"></Skeleton>
						<div v-else>
							<ButtonPrime v-tooltip.bottom="'Delete'" icon="pi pi-trash" outlined rounded
								severity="danger" size="small" @click="deleteItem(slotProps.data)" />
						</div>
					</template>
				</Column>
				<template #empty>
					<div style="text-align: center; padding: 40px 0;">
						<img src="/no_data.png" alt="No Data"
							style="max-width: 330px; opacity: 0.7; margin-bottom: 0;" />
						<div style="color: #888; font-size: 1.1em; font-weight: 500;">
							No Data
						</div>
					</div>
				</template>
			</DataTable>
		</div>

		<!-- McrItemFormDialog (Reusable) -->
		<McrItemFormDialog ref="mcrItemDialog" :form-config="mcrDetail.formConfig" :view-data="viewData" :client-code="clientCode"
			:company-code="companyCode" :mcr-type="mcrType" :max-validation="maxValidation" :readonly="readonly"
			:draft-id="$route.params.id" @saved="onItemDialogSaved" />

		<AddNoteItemModal v-model:visible="noteModal.visible" :item="noteModal.item" @saved="onNotesSaved" />
		<CheckDuplicateModal v-model:visible="checkDuplicateModal.visible" :mcr-item="checkDuplicateModal.item" :row-number="checkDuplicateModal.rowNumber" @saved="onStatusSaved" />
	</div>
</template>

<script>
import userFormService from '@/services/materialCatalogingRequest/userFormService';
import api from "@/helpers/api";
import setMaxSize from "@/helpers/setMaxSize";
import { mapState } from "vuex";
import McrItemFormDialog from './McrItemFormDialog.vue';
import AddNoteItemModal from './modules/cataloguer/AddNoteItemModal.vue';
import CheckDuplicateModal from './modules/cataloguer/CheckDuplicateModal.vue';
import mcrItemActionsMixin from './modules/New_mcrItemActionsMixin';

export default {
	props: {
		readonly: { type: Boolean, default: false }
	},
	components: { McrItemFormDialog, AddNoteItemModal, CheckDuplicateModal },
	// Tombol MCR Item Note / Check Duplicate / Cancel: modal & handler-nya dari mixin, aturan tampilnya di sini.
	mixins: [mcrItemActionsMixin],
	data() {
		return {
			selectedItemId: null,
			dummyRows: Array.from({ length: 10 }, () => ({})),
			formConfig: null,
			maxValidation: {
				size: 2000000,
				text: "Max Size 2000 KB"
			},
			clientCode: "",
			companyCode: "",
		};
	},
	computed: {
		...mapState({
			mcrHeader: (state) => state.mcr.mcrHeader,
			allMcrItem: (state) => state.mcr.allMcrItem || [],
			isLoadingMcr: (state) => state.mcr.isLoading || {},
			mcrDetail: (state) => state.mcr.mcrDetail
		}),
		// Data MCR (header) & item TIDAK di-fetch lokal lagi: SATU sumber di store `mcr` (mcrHeader &
		// allMcrItem, diisi action mcr/fetchMcrHeader dari request-pool/request-list/{id}). Prop
		// `view-data` ke McrItemFormDialog juga dibaca dari store, bukan state lokal.
		viewData() {
			return this.mcrHeader;
		},
		items() {
			return this.allMcrItem;
		},
		isTableLoading() {
			return !!this.isLoadingMcr.header;
		},
		mcrType() {
			return (this.mcrHeader?.type || this.viewData?.type || '').toLowerCase().replace(/\s+/g, '-');
		},
		isV2Flow() {
			return ['draft', 'material-request', 'my-task'].some(seg => this.$route.path.includes(seg));
		},
		isService() {
			const t = (this.mcrType || '').toLowerCase();
			return t === 'mcr008' || t === 'mcr009' || t.includes('service');
		},
	},
	watch: {
		'$route.params': {
			handler(newQuery) {
				if (newQuery.id) {
					this.checkViewMode();
				}
			},
			immediate: false
		},
	},
	mounted() {
		const userAuth = JSON.parse(localStorage.getItem('userAuth') || '{}');
		this.clientCode = userAuth?.user?.client_code || '';
		this.companyCode = userAuth?.user?.company_code || '';
		this.checkViewMode();
		this.getMaxSizeConfig();
	},
	methods: {
		truncateText(text, maxLength = 40) {
			const str = text ? String(text) : '';
			if (str.length <= maxLength) return str;
			const sliced = str.slice(0, maxLength);
			const lastSpace = sliced.lastIndexOf(' ');
			const safeSlice = lastSpace > 0 ? sliced.slice(0, lastSpace) : sliced;
			return `${safeSlice} ...`;
		},
		onRowSelect(event) {
			this.selectedItemId = event.data.id;
			// masukkan item selected ke vue setSelectedMcrItem
			this.$store.commit('mcr/setSelectedMcrItem', event.data);
			// Buka dialog edit via komponen McrItemFormDialog
			this.$refs.mcrItemDialog?.openForEdit(event.data.mcr_item_code);
		},
		rowClass(data) {
			return this.selectedItemId === data.id ? 'row-active' : '';
		},
		// Aturan tombol (lihat New_mcrItemActionsMixin.js). cat_po_horizontal biasanya belum terisi di tahap UserForm (baru diisi
		// cataloguer), jadi pengecekan duplikat di sini praktisnya cuma efektif lewat emcr_item_manufacturer (spn).
		hasDuplicateSource(data) {
			const hasLongDesc = !!(data?.cat_po_horizontal && data.cat_po_horizontal.trim());
			const hasSpn = Array.isArray(data?.emcr_item_manufacturer)
				&& data.emcr_item_manufacturer.some((m) => m?.spn && m.spn.trim());
			return hasLongDesc || hasSpn;
		},
		// Role User tidak bisa meng-cancel item yang masih draft.
		cancelVisible(data) {
			return !(this.isUserRole && data?.status === 'draft');
		},
		// CheckDuplicateModal baca cat_emcr_item_manufacturer; item mentah di sini cuma punya emcr_item_manufacturer.
		toCheckDuplicateItem(item) {
			return { ...item, cat_emcr_item_manufacturer: item.emcr_item_manufacturer || [] };
		},
		statusBadgeClass(status) {
			const map = {
				sap: 'bg-success',
				catalogued: 'bg-primary',
				canceled: 'bg-danger',
				error: 'bg-danger',
				draft: 'bg-secondary',
			};
			if (map[status]) return map[status];
			return String(status || '').startsWith('duplicated') ? '' : 'bg-secondary';
		},
		// 'purple' bukan bagian dari $theme-colors Argon (cuma di $colors), jadi ga ada kelas bg-purple siap pakai — pakai inline style
		statusBadgeStyle(status) {
			return String(status || '').startsWith('duplicated') ? { backgroundColor: '#6f42c1' } : {};
		},
		statusBadgeLabel(status) {
			const map = {
				sap: 'SAP',
				catalogued: 'CAT',
				canceled: 'CANC',
				error: 'ERR',
				draft: 'DRF',
			};
			if (map[status]) return map[status];
			return String(status || '').startsWith('duplicated') ? 'DUPL' : status;
		},
		// Tooltip cuma muncul untuk status catalogued/canceled/duplicated, dan cuma kalau data pelakunya ada.
		statusBadgeTooltip(data) {
			const status = data?.status;
			const by = data?.catalogued_by || {};
			if (status === 'catalogued' && by.catalogued_by?.name) {
				return `Catalogued By : ${by.catalogued_by.name}`;
			}
			if (status === 'canceled' && by.canceled_by?.name) {
				return `Canceled By : ${by.canceled_by.name}`;
			}
			if (String(status || '').startsWith('duplicated') && by.duplicated_by?.name) {
				return `Duplicated By : ${by.duplicated_by.name}`;
			}
			return null;
		},
		async checkViewMode() {
			const { id } = this.$route.params;
			if (!id) return;
			// New_McrForm sudah mengambil header sebelum komponen ini dirender -- kalau id-nya masih sama,
			// jangan request ulang (cukup saat route pindah ke MCR lain).
			if (String(this.mcrHeader?.id ?? '') !== String(id)) {
				await this.refreshViewData();
				return;
			}
			this.notifyMultipleItems();
		},
		// Ambil ulang MCR + item dari request list lewat store (dipakai saat route pindah, sesudah item
		// disimpan/diupdate, dan sesudah item dihapus).
		async refreshViewData() {
			const id = this.$route.params.id;
			if (!id) return;
			try {
				await this.$store.dispatch('mcr/fetchMcrHeader', { id });
				this.notifyMultipleItems();
			} catch (error) {
				console.error('Error fetching MCR data:', error);
				this.$toastNotifPrime('error', 'Error', 'Failed to load MCR data');
			}
		},
		notifyMultipleItems() {
			if ((this.items || []).length > 1) {
				this.$toastNotifPrime('info', 'Multiple Items', `This MCR has ${this.items.length} items.`);
			}
		},
		deleteItem(item) {
			if (!item || !item.id) return;
			this.confirmDialog("Are you sure you want to delete this item?", "delete it").then(async (result) => {
				if (result.isConfirmed) {
					try {
						await api(this, userFormService.delete(item.id), true);
						await this.refreshViewData();
					} catch (error) {
						console.error('Error deleting item:', error);
					}
				}
			});
		},
		addNewItem() {
			this.$refs.mcrItemDialog?.openForAdd();
		},
		onItemDialogSaved() {
			// Refresh MCR + item di store setelah item disimpan/diupdate.
			this.refreshViewData();
		},
		async getMaxSizeConfig() {
			try {
				const result = await setMaxSize();
				if (result) {
					this.maxValidation.size = result.data.data.maximum_file;
					this.maxValidation.text = `Max Size ${result.data.data.maximum_file / 1000} KB`;
				}
			} catch (error) {
				this.maxValidation.size = 2000000;
				this.maxValidation.text = `Max Size ${this.maxValidation.size / 1000} KB`;
			}
		},
	},
};
</script>

<style scoped>
:deep(.compact-table .p-datatable-tbody > tr > td) {
	padding: 0.35rem 0.5rem;
}

:deep(.compact-table .p-datatable-thead > tr > th) {
	padding: 0.4rem 0.5rem;
}

:deep(.p-datatable-sm .p-datatable-tbody > tr > td) {
	font-size: 0.875rem;
	padding: 0.35rem 0.5rem;
}

:deep(.p-datatable-sm .p-datatable-thead > tr > th) {
	font-size: 0.875rem;
	padding: 0.4rem 0.5rem;
}

/* Tabel item: satu baris per item (tidak ada teks yang turun baris), geser kiri-kanan kalau kolomnya melebihi lebar card.
   Isi sel dibatasi lebarnya -- teks yang lebih panjang dipotong "..." (nilai lengkap lewat tooltip / buka item). */
:deep(.user-item-table .p-datatable-thead > tr > th),
:deep(.user-item-table .p-datatable-tbody > tr > td) {
	white-space: nowrap;
}

:deep(.user-item-table .p-datatable-tbody > tr > td:not(.cell-actions) > span) {
	display: inline-block;
	max-width: 220px;
	overflow: hidden;
	text-overflow: ellipsis;
	vertical-align: middle;
}

:deep(.row-active) {
	background-color: #fff9db !important;
}

:deep(.row-active:hover) {
	background-color: #fff9db !important;
}
</style>